import {Component, Host, Element, Prop, h, Method, Event, EventEmitter} from "@stencil/core";
import {AccordionStateEnum} from "./domain/AccordionStateEnum";
import {AccordionEvent} from "./domain/AccordionEvent";

@Component({
  tag: 'snt-accordion',
  styleUrl: 'accordion-component.scss',
  shadow: false
})
export class AccordionComponent {

  public static readonly TAG_NAME = "snt-accordion";

  @Prop({ mutable: true, reflect: true }) public expanded: boolean = false;
  
  @Event({ bubbles: true }) private accordionEvent: EventEmitter<object>;

  @Element() private element!: HTMLElement;

  @Method()
  async isCollapsed() {
    return Promise.resolve(!this.expanded);
  }

  @Method()
  async isExpanded() {
    return Promise.resolve(this.expanded);
  }

  @Method()
  async collapse() {
    this.expanded = false;
  }

  @Method()
  async expand() {
    this.expanded = true;
  }

  @Method()
  async toggle() {
    this.accordionEvent.emit(new AccordionEvent(this.expanded ? AccordionStateEnum.COLLAPSED : AccordionStateEnum.EXPANDED));
    if (this.expanded) {
      this.collapse();
    }
    else {
      this.expand();
    }
  }

  private getExpandIcon(isTranscriptAccordion, isExpanded) {
    return isTranscriptAccordion == true  
    ?  <span class={`expand-icon icon-font ${isExpanded ? 'icon-icon_legalAccordion_minus' : 'icon-icon_legalAccordion_plus'}`}></span>
    : null;
  }


  render() {
    const accordionId = this.element.id;
    const panelClass = `card-panel collapse ${this.expanded ? "show" : ""}`;
    const ariaExpanded = (this.expanded) ? "true" : "false";
    const isTranscriptAccordion = this.element.classList.contains('transcript-accordion');
    const isLegalFooterAccordion = this.element.classList.contains('legal-footer-accordion');
    const accordionTextShow = this.element.getAttribute('accordionTextShow');
    const accordionTextHide = this.element.getAttribute('accordionTextHide');
    return (
      <Host expanded={this.expanded}>
          <div class={`card pas-accordion ${isLegalFooterAccordion ? 'legal-footer-accordion' : ''}`}>
            <div id={`${accordionId}-header`} class="card-header">
                <button onClick={this.toggle.bind(this)} class="btn accordion-btn" aria-expanded={ariaExpanded} aria-controls={`${accordionId}-panel`}>
                  {this.getExpandIcon(isTranscriptAccordion, this.expanded)}
                  {isLegalFooterAccordion && <span class="accordion-button-text">{this.expanded ? accordionTextHide : accordionTextShow}</span>}
                  <div class={`mb-0 ${isTranscriptAccordion ? '' : 'h4'}`}>
                    <h2 class="h4">
                    <slot name="summary" />
                    </h2>
                  </div>
                </button>
            </div>
            <div id={`${accordionId}-panel`} class={panelClass} aria-labelledby={`${accordionId}-header`}>
              <div class="card-body">
                <slot name="details" />
              </div>
            </div>
          </div>
      </Host>
    );
  }
}
